import L from 'leaflet';

// Fix for default marker icon issue in Leaflet with Webpack
// delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: undefined,
  iconUrl: undefined,
  shadowUrl: undefined
});

const createSvgIcon = (svgPath: string, color: string) => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" 
         fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      ${svgPath}
    </svg>
  `;

  return L.divIcon({
    html: svg,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
    popupAnchor: [0, -12],
    className: 'custom-svg-icon'
  });
};

/** lucide warehouse */
export const warehouseIcon = (color = '#3b82f6') =>
  createSvgIcon(
    '<path d="M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z"></path><path d="M6 18h12"></path><path d="M6 14h12"></path><rect width="12" height="12" x="6" y="10"></rect>',
    color
  );

/** lucide anchor */
export const portIcon = (color = '#10b981') =>
  createSvgIcon(
    '<path d="M12 22V8"></path><path d="M5 12H2a10 10 0 0 0 20 0h-3"></path><circle cx="12" cy="5" r="3"></circle>',
    color
  );

/** lucide users */
export const customerIcon = (color = '#f97316') =>
  createSvgIcon(
    '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>',
    color
  );

/** lucide building2 */
export const siteIcon = (color = '#a855f7') =>
  createSvgIcon(
    '<path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path><path d="M10 6h4"></path><path d="M10 10h4"></path><path d="M10 14h4"></path><path d="M10 18h4"></path>',
    color
  );

export const getLocationIcon = (type: string, isSelected = false) => {
  const iconMap: Record<string, L.DivIcon> = {
    W: warehouseIcon('#3b82f6'),
    P: portIcon('#10b981'),
    C: customerIcon('#f97316'),
    S: siteIcon('#a855f7')
  };

  const icon = iconMap[type] || customerIcon('#6b7280');

  if (isSelected) {
    // Return a larger version for selected items
    icon.options.iconSize = [36, 36];
    icon.options.iconAnchor = [18, 18];
  }

  return icon;
};

export const getLocationColor = (type: string): string => {
  const colors: Record<string, string> = {
    /** blue-500 */
    W: '#3b82f6',
    /** green-500 */
    P: '#10b981',
    /** orange-500 */
    C: '#f97316',
    /** purple-500 */
    S: '#a855f7'
  };
  return colors[type] || '#6b7280';
};
